/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEmployee201Response,
  CreateEmployeeAttendanceRequest,
  CreateEmployeeRequest,
  GetEmployeeAttendance200Response,
  GetEmployeeAttendanceById200Response,
  GetEmployeeConfig200Response,
  GetEmployees200ResponseInner,
  GetProductsFiltersParameterInnerInner,
  GetProductsPaginationParameter,
  GetProductsSortingParameterInner,
  OverrideEmployeeAttendanceRequest,
} from '../models/index';
import {
    CreateEmployee201ResponseFromJSON,
    CreateEmployee201ResponseToJSON,
    CreateEmployeeAttendanceRequestFromJSON,
    CreateEmployeeAttendanceRequestToJSON,
    CreateEmployeeRequestFromJSON,
    CreateEmployeeRequestToJSON,
    GetEmployeeAttendance200ResponseFromJSON,
    GetEmployeeAttendance200ResponseToJSON,
    GetEmployeeAttendanceById200ResponseFromJSON,
    GetEmployeeAttendanceById200ResponseToJSON,
    GetEmployeeConfig200ResponseFromJSON,
    GetEmployeeConfig200ResponseToJSON,
    GetEmployees200ResponseInnerFromJSON,
    GetEmployees200ResponseInnerToJSON,
    GetProductsFiltersParameterInnerInnerFromJSON,
    GetProductsFiltersParameterInnerInnerToJSON,
    GetProductsPaginationParameterFromJSON,
    GetProductsPaginationParameterToJSON,
    GetProductsSortingParameterInnerFromJSON,
    GetProductsSortingParameterInnerToJSON,
    OverrideEmployeeAttendanceRequestFromJSON,
    OverrideEmployeeAttendanceRequestToJSON,
} from '../models/index';

export interface CancelEmployeeAttendanceRequest {
    attendanceId: string;
}

export interface CreateEmployeeOperationRequest {
    createEmployeeRequest: CreateEmployeeRequest;
}

export interface CreateEmployeeAttendanceOperationRequest {
    createEmployeeAttendanceRequest: CreateEmployeeAttendanceRequest;
}

export interface DeleteEmployeeRequest {
    employeeId: string;
}

export interface GetEmployeeAttendanceRequest {
    pagination?: GetProductsPaginationParameter;
    filters?: Array<Array<GetProductsFiltersParameterInnerInner>>;
    sorting?: Array<GetProductsSortingParameterInner>;
    startDate?: Date;
    endDate?: Date;
}

export interface GetEmployeeAttendanceByIdRequest {
    attendanceId: string;
}

export interface OverrideEmployeeAttendanceOperationRequest {
    attendanceId: string;
    overrideEmployeeAttendanceRequest: OverrideEmployeeAttendanceRequest;
}

export interface RestoreEmployeeAttendanceRequest {
    attendanceId: string;
}

export interface UpdateEmployeeRequest {
    employeeId: string;
    getEmployees200ResponseInner: GetEmployees200ResponseInner;
}

export interface UpdateEmployeeConfigRequest {
    getEmployeeConfig200Response: GetEmployeeConfig200Response;
}

/**
 * 
 */
export class EmployeesApi extends runtime.BaseAPI {

    /**
     */
    async cancelEmployeeAttendanceRaw(requestParameters: CancelEmployeeAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling cancelEmployeeAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/attendance/{attendanceId}`.replace(`{${"attendanceId"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async cancelEmployeeAttendance(requestParameters: CancelEmployeeAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelEmployeeAttendanceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createEmployeeRaw(requestParameters: CreateEmployeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmployee201Response>> {
        if (requestParameters['createEmployeeRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmployeeRequest',
                'Required parameter "createEmployeeRequest" was null or undefined when calling createEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/employees/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployeeRequestToJSON(requestParameters['createEmployeeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmployee201ResponseFromJSON(jsonValue));
    }

    /**
     */
    async createEmployee(requestParameters: CreateEmployeeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmployee201Response> {
        const response = await this.createEmployeeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createEmployeeAttendanceRaw(requestParameters: CreateEmployeeAttendanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['createEmployeeAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmployeeAttendanceRequest',
                'Required parameter "createEmployeeAttendanceRequest" was null or undefined when calling createEmployeeAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/employees/attendance/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmployeeAttendanceRequestToJSON(requestParameters['createEmployeeAttendanceRequest']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async createEmployeeAttendance(requestParameters: CreateEmployeeAttendanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createEmployeeAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteEmployeeRaw(requestParameters: DeleteEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling deleteEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/{employeeId}`.replace(`{${"employeeId"}}`, encodeURIComponent(String(requestParameters['employeeId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteEmployee(requestParameters: DeleteEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmployeeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getEmployeeAttendanceRaw(requestParameters: GetEmployeeAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmployeeAttendance200Response>> {
        const queryParameters: any = {};

        if (requestParameters['pagination'] != null) {
            queryParameters['pagination'] = requestParameters['pagination'];
        }

        if (requestParameters['filters'] != null) {
            queryParameters['filters'] = requestParameters['filters'];
        }

        if (requestParameters['sorting'] != null) {
            queryParameters['sorting'] = requestParameters['sorting'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/attendance/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployeeAttendance200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeeAttendance(requestParameters: GetEmployeeAttendanceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmployeeAttendance200Response> {
        const response = await this.getEmployeeAttendanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeeAttendanceByIdRaw(requestParameters: GetEmployeeAttendanceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmployeeAttendanceById200Response>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling getEmployeeAttendanceById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/attendance/{attendanceId}`.replace(`{${"attendanceId"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployeeAttendanceById200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeeAttendanceById(requestParameters: GetEmployeeAttendanceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmployeeAttendanceById200Response> {
        const response = await this.getEmployeeAttendanceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeeConfigRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmployeeConfig200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/config/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmployeeConfig200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async getEmployeeConfig(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmployeeConfig200Response> {
        const response = await this.getEmployeeConfigRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmployeesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetEmployees200ResponseInner>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetEmployees200ResponseInnerFromJSON));
    }

    /**
     */
    async getEmployees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetEmployees200ResponseInner>> {
        const response = await this.getEmployeesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async overrideEmployeeAttendanceRaw(requestParameters: OverrideEmployeeAttendanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling overrideEmployeeAttendance().'
            );
        }

        if (requestParameters['overrideEmployeeAttendanceRequest'] == null) {
            throw new runtime.RequiredError(
                'overrideEmployeeAttendanceRequest',
                'Required parameter "overrideEmployeeAttendanceRequest" was null or undefined when calling overrideEmployeeAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/employees/attendance/{attendanceId}/override`.replace(`{${"attendanceId"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OverrideEmployeeAttendanceRequestToJSON(requestParameters['overrideEmployeeAttendanceRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async overrideEmployeeAttendance(requestParameters: OverrideEmployeeAttendanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.overrideEmployeeAttendanceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async restoreEmployeeAttendanceRaw(requestParameters: RestoreEmployeeAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['attendanceId'] == null) {
            throw new runtime.RequiredError(
                'attendanceId',
                'Required parameter "attendanceId" was null or undefined when calling restoreEmployeeAttendance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/employees/attendance/{attendanceId}/restore`.replace(`{${"attendanceId"}}`, encodeURIComponent(String(requestParameters['attendanceId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async restoreEmployeeAttendance(requestParameters: RestoreEmployeeAttendanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.restoreEmployeeAttendanceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateEmployeeRaw(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['employeeId'] == null) {
            throw new runtime.RequiredError(
                'employeeId',
                'Required parameter "employeeId" was null or undefined when calling updateEmployee().'
            );
        }

        if (requestParameters['getEmployees200ResponseInner'] == null) {
            throw new runtime.RequiredError(
                'getEmployees200ResponseInner',
                'Required parameter "getEmployees200ResponseInner" was null or undefined when calling updateEmployee().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/employees/{employeeId}`.replace(`{${"employeeId"}}`, encodeURIComponent(String(requestParameters['employeeId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetEmployees200ResponseInnerToJSON(requestParameters['getEmployees200ResponseInner']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEmployee(requestParameters: UpdateEmployeeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmployeeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateEmployeeConfigRaw(requestParameters: UpdateEmployeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['getEmployeeConfig200Response'] == null) {
            throw new runtime.RequiredError(
                'getEmployeeConfig200Response',
                'Required parameter "getEmployeeConfig200Response" was null or undefined when calling updateEmployeeConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/employees/config/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GetEmployeeConfig200ResponseToJSON(requestParameters['getEmployeeConfig200Response']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateEmployeeConfig(requestParameters: UpdateEmployeeConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateEmployeeConfigRaw(requestParameters, initOverrides);
    }

}
